<template>

  <form id="modelForm" class="mx-auto col-sm-8" @submit.prevent>

    <div class="form-group">
      <label for="active_type">{{ $t('active_type') }}</label>
      <Combobox
        class="bg-white"
        :hasErrors="errors.has('active_type')"
        name='active_type'
        :placeholder="$t('select_a_item')"
        label="name"
        :options="activestypes"
        :initial-value="model.activeType"
        v-model="model.activeType"
        :reduce="activeType => activeType.id"
        v-validate="'required'"
      />

      <small v-show="errors.has('active_type')" class="form-text">
        {{ errors.first('active_type') }}
      </small>
    </div>

    <div class="form-group" v-show="model.activeType === 10">
      <label for="version">{{ $t('version') }}</label>
      <Combobox
        class="bg-white"
        :hasErrors="errors.has('version')"
        name='version'
        :placeholder="$t('select_a_item')"
        label="VER_COD"
        :options="versions"
        :initial-value="model.version"
        v-model="model.version"
        :reduce="version => version.VER_ID"
        v-validate="`${validateVersion}`"
      />

      <small v-show="errors.has('version')" class="form-text">
        {{ errors.first('version') }}
      </small>
    </div>

    <div class="form-group" :class="{ 'has-error': errors.has('model') }">
      <label for="model">{{ $t('model') }}</label>
      <input
        type="text"
        id="model"
        name="model"
        class="form-control"
        :placeholder="$t('ph_model')"
        v-model="model.name"
        v-validate="'required'"
        @input="model.name = model.name.toUpperCase()"
      >

      <small v-show="errors.has('model')" class="form-text text-danger">
        {{ errors.first('model') }}
      </small>
    </div>

    <div class="form-group">
      <label for="manufacturer">{{ $t('manufacturer') }}</label>
      <Combobox
        class="bg-white"
        name='manufacturer'
        :hasErrors="errors.has('manufacturer')"
        :placeholder="$t('select_a_item')"
        label="name"
        :options="manufacturers"
        :initial-value="model.manufacturer"
        v-model="model.manufacturer"
        :reduce="model => model.id"
        v-validate="'required'"
      />
      <small v-show="errors.has('manufacturer')" class="form-text">
        {{ errors.first('manufacturer') }}
      </small>
    </div>

    <div class="switch mb-3">
      <label for="canLinkSimcard">{{ $t('link_simcard') }}</label>
      <div class="onoffswitch2">
        <input
          type="checkbox"
          class="onoffswitch2-checkbox"
          id="canLinkSimcard"
          v-model="model.canLinkSimcard"
        >

        <label class="onoffswitch2-label" for="canLinkSimcard">
            <span class="onoffswitch2-inner"></span>
            <span class="onoffswitch2-switch"></span>
        </label>
      </div>
    </div>

    <div class="switch mb-3">
      <label for="isActive">{{ $t('active') }}</label>
      <div class="onoffswitch2">
        <input
          type="checkbox"
          class="onoffswitch2-checkbox"
          id="isActive"
          v-model="model.isActive">
        <label class="onoffswitch2-label" for="isActive">
            <span class="onoffswitch2-inner"></span>
            <span class="onoffswitch2-switch"></span>
        </label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="onClick">
          {{ $t('save') }}
        </LoaderButton>
      </div>
    </div>

  </form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import location from '@/config/locations'
import Combobox from '@/components/shared/ComboBox'
import { request } from '@/lib/http'

export default {
  name: 'ModelForm',
  components: {
    LoaderButton,
    Combobox
  },
  data: () => ({
    locations: location,
    versions: [],
    validateVersion: ''
  }),

  props: {
    model: {
      type: Object,
      default: () => ({
        name: '',
        manufacturer: undefined,
        activeType: undefined,
        version: undefined,
        canLinkSimcard: false,
        isActive: true,
      })
    }
  },

  computed: {
    ...mapState({
      manufacturers: state => state.manufacturer.all,
      models: state => state.model.all,
      activestypes: state => state.activestype.all,
    })
  },

  watch: {
    'model.activeType': function(value) {
      if (value === 10) {
        this.validateVersion = 'required'
      } else {
        this.validateVersion = ''
        this.model.version = undefined
      }
    }
  },

  methods: {
    ...mapActions('model', [
      'create',
      'edit',
      'cleanState'
    ]),

    async onClick (evtClick, doneFn) {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const { id } = this.model

      if (this.model.version === null) {
        delete this.model.version
      }

      const result = id
        ? await this.edit({ id, data: this.model })
        : await this.create(this.model)

      if (result) {
        this.$router.push({ name: 'listmodels' })
      }
    }
  },

  async mounted() {
    const { dispatch } = this.$store

    await dispatch('activestype/fetchAll')
    await dispatch('manufacturer/fetchAll')

    this.versions = await request({
      url: 'tracker-versions',
      method: 'get'
    })

    if (this.$route.params.id) {
      if (this.model.activeType == 10) {
        this.validateVersion = 'required'
      }
    }
  },

  destroyed () {
    this.cleanState()

    this.$store.dispatch('activestype/cleanState')
    this.$store.dispatch('manufacturer/cleanState')
  }
}
</script>
